/**
 * Default tool definitions for Agentic AI
 */

export const DEFAULT_TOOLS = [
    {
        name: 'TodoWrite',
        description: 'Track tasks and todos in your workflow',
        source: 'claude-sdk-builtin'
    }
];

/**
 * Mandatory tools that cannot be disabled (enforced by backend)
 * These tools will always be available regardless of user selection
 */
export const MANDATORY_TOOLS = ['TodoWrite'];

export default DEFAULT_TOOLS;
